// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".details-list[data-v-0987dbc8]{list-style:none;padding-left:0}.details-list-title[data-v-0987dbc8]{font-size:16px;font-weight:500;font-family:\"Jost\";margin-bottom:0;text-transform:uppercase;letter-spacing:.5px}.details-list-item[data-v-0987dbc8]{display:flex;justify-content:space-between;border-top:1px solid #f1f1f1;padding:6px 0;font-size:16px}.details-list-item__right[data-v-0987dbc8]{font-weight:500}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
